import { render, staticRenderFns } from "./CadastreSectionEditModal.vue?vue&type=template&id=bea8b04a&scoped=true&"
import script from "./CadastreSectionEditModal.vue?vue&type=script&lang=js&"
export * from "./CadastreSectionEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea8b04a",
  null
  
)

export default component.exports